<template>
  <div class="tabpage">
    <b-card no-body>
      <b-tabs card @input="handleTabChange">
        <b-tab title="硬件" :active="activeTabIndex === 0">
          <div id="page1">
            <p class="p-a">网关类产品价格、库存表</p>
            <table>
              <thead>
                <tr>
                  <th style="width: 130px;" scope="col" class="text-center">网关产品</th>
                  <th style="width: 380px;" scope="col" class="text-center">价格: 元(人民币)/台，包含一年(12个月)的流量套餐</th>
                  <th style="width: 130px;" scope="col" class="text-center">库存数量</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(val1, index1) in product" :key="index1">
                  <td class="text-left">{{ val1.prodname }}</td>
                  <td class="text-right">{{ val1.prodprice }}</td>
                  <td class="text-right">
                    <div v-if="val1.quantity !== null">
                      {{ val1.quantity }}
                    </div>
                    <div v-else>
                      无限
                    </div>
                  </td>
                </tr>
              </tbody>
            </table> 
            <p class="p-b">企业网关: 既是服务器, 也是客户端, 单节点企业网关只作为服务器, 其它认证的设备通过企业网关访问企业或家庭内网</p>
            <p class="p-b">移动网关: 只是客户端, 允许其它设备通过连入移动网关访问企业或家庭内网</p>
            <p class="p-b">移动终端: 一般只作为客户端访问企业或家庭内网, 通常是定制的安卓手机或平板电脑</p>
        
            <div style="margin-top: 10px;margin-left: 0;align-items: center;">
              <span style="margin-right: 5px;">请选择企业网关(低端)数量:</span>
              <input style="width: 60px;" type="number" v-model.number="lowgw" :min="0" :max="lowgw_max" :disabled="lowgw_max === 0" onkeyup="value=value.replace(/\D/g,'')" onafterpaste="value=value.replace(/\D/g,'')" @input="validate($event, 'lowgw', lowgw_max)" @change='setProductPrice'/>
          
              <span style="margin-left: 30px; margin-right: 10px">请输入移动网关(低端)数量:</span>
              <input style="width: 60px;" type="number" v-model.number="lowmgw" :min="0" :max="lowmgw_max" :disabled="lowmgw_max === 0" onkeyup="value=value.replace(/\D/g,'')" onafterpaste="value=value.replace(/\D/g,'')" @input="validate($event, 'lowmgw', lowmgw_max)" @change='setProductPrice'/>
          
              <span style="margin-left: 30px; margin-right: 10px">请输入移动终端(低端)数量:</span>
              <input style="width: 60px;" type="number" v-model.number="lowmterm" :min="0" :max="lowmterm_max" :disabled="lowmterm_max === 0" onkeyup="value=value.replace(/\D/g,'')" onafterpaste="value=value.replace(/\D/g,'')"  @input="validate($event, 'lowmterm', lowmterm_max)" @change='setProductPrice'/>
            </div>
        
            <div style="margin-top: 10px;margin-left: 0;align-items: center;">
              <span style="margin-right: 5px;">请选择企业网关(中端)数量:</span>
              <input style="width: 60px;" type="number" v-model.number="midgw" :min="0" :max="midgw_max" :disabled="midgw_max === 0" onkeyup="value=value.replace(/\D/g,'')" onafterpaste="value=value.replace(/\D/g,'')" @input="validate($event, 'midgw', midgw_max)" @change='setProductPrice'/>
          
              <span style="margin-left: 30px; margin-right: 10px">请输入移动网关(中端)数量:</span>
              <input style="width: 60px;" type="number" v-model.number="midmgw" :min="0" :max="midmgw_max" :disabled="midmgw_max === 0" onkeyup="value=value.replace(/\D/g,'')" onafterpaste="value=value.replace(/\D/g,'')" @input="validate($event, 'midmgw', midmgw_max)" @change='setProductPrice'/>
          
              <span style="margin-left: 30px; margin-right: 10px">请输入移动终端(中端)数量:</span>
              <input style="width: 60px;" type="number" v-model.number="midmterm" :min="0" :max="midmterm_max" :disabled="midmterm_max === 0" onkeyup="value=value.replace(/\D/g,'')" onafterpaste="value=value.replace(/\D/g,'')"  @input="validate($event, 'midmterm', midmterm_max)" @change='setProductPrice'/>
            </div>

            <div style="margin-top: 10px;margin-left: 0;align-items: center;">
              <span style="margin-right: 5px;">请选择企业网关(高端)数量:</span>
              <input style="width: 60px;" type="number" v-model.number="highgw" :min="0" :max="highgw_max" :disabled="highgw_max === 0" onkeyup="value=value.replace(/\D/g,'')" onafterpaste="value=value.replace(/\D/g,'')" @input="validate($event, 'highgw', highgw_max)" @change='setProductPrice'/>
          
              <span style="margin-left: 30px; margin-right: 10px">请输入移动网关(高端)数量:</span>
              <input style="width: 60px;" type="number" v-model.number="highmgw" :min="0" :max="highmgw_max" :disabled="highmgw_max === 0" onkeyup="value=value.replace(/\D/g,'')" onafterpaste="value=value.replace(/\D/g,'')" @input="validate($event, 'highmgw', highmgw_max)" @change='setProductPrice'/>
          
              <span style="margin-left: 30px; margin-right: 10px">请输入移动终端(高端)数量:</span>
              <input style="width: 60px;" type="number" v-model.number="highmterm" :min="0" :max="highmterm_max" :disabled="highmterm_max === 0" onkeyup="value=value.replace(/\D/g,'')" onafterpaste="value=value.replace(/\D/g,'')"  @input="validate($event, 'highmterm', highmterm_max)" @change='setProductPrice'/>
            </div>

            <div style="margin-top: 40px; width: 600px; align-items: center;">
              <span style="margin-right: 5px;">您需要付款:</span>
              <span style="color:#003D79;font-weight:bold;">{{ product_price }}</span>
              <span style="margin-left: 5px;">元(人民币)</span>
            </div>
        
            <div class="payinfo" style="margin-top: 10px;">
              <span style="height:50px;line-height:50px;">支付方式:</span>
              <div class="waiwei">
                <img
                  src="../assets/media/alipay.png"
                  style="width: 32px;height 32px;margin-left: 5px;float: left;"
                >
                <span style="cursor:default;float:right;margin-left:5px;">支付宝</span>
              </div>
              <button  @click="alipay('page1' + '|' + lowgw + 'lowgw_' + midgw + 'midgw_' + highgw + 'highgw_' + lowmgw + 'lowmgw_' + midmgw + 'midmgw_' + highmgw + 'highmgw_' + lowmterm + 'lowmterm_' + midmterm + 'midmterm_' + highmterm  + 'highmterm')">立即支付</button>
            </div>
        
            <div v-if="message1" class="message">
              <p>{{ message1 }}</p>
            </div>
        
          </div>
        </b-tab>
        
        <b-tab title="流量" :active="activeTabIndex === 1">
          <div id="page2">
            <p class="p-a">流量套餐价格表 单位: 元 (人民币)</p>
            <table>
              <tr>
                <th class="slash-wrap">
                  <span class="left">流量套餐</span>
                  <span class="slash"></span>
                  <span class="right">价格</span>
                </th>
                <th class="t-body">以单台设备为单位, 不限流量</th>
              </tr>
              <tr v-for="(val2, index2) in plan" :key="index2">
                <td>{{ val2.planname }}</td>
                <td align="right">{{ val2.planprice }}</td>
              </tr>
            </table> 
            <p class="p-b">公式: 总费用 = (企业网关数 + 移动网关数 + 移动终端数) * 流量套餐价格</p>
        
            <div style="margin-top: 10px;margin-left: 0;align-items: center;">
              <span style="margin-right: 5px;">请选择流量套餐:</span>
              <select id="plan_select" v-model="plan_selected" @change="setPlanPrice()" >
                <option v-for="(item, i) in plan"  :value="item.planid + '|' + item.planprice + '|' + item.planname">{{ item.planname }}</option>
              </select>
          
            <div style="margin-top: 160px; width: 600px; align-items: center;">
              <span style="margin-right: 5px;">您需要付款:</span>
              <span style="color:#003D79;font-weight:bold;">{{ plan_price }}</span>
              <span style="margin-left: 5px;">元(人民币)</span>
            </div>
        
            <div class="payinfo" style="margin-top: 10px;">
              <span style="height:50px;line-height:50px;">支付方式:</span>
              <div class="waiwei">
                <img
                  src="../assets/media/alipay.png"
                  style="width: 32px;height 32px;margin-left: 5px;float: left;"
                >
                <span style="cursor:default;float:right;margin-left:5px;">支付宝</span>
              </div>
              <button  @click="alipay('page2' + '|' + plan_selected.split('|')[0] + 'plan|' + plan_selected.split('|')[2])">立即支付</button>
            </div>
        
            <div v-if="message2" class="message">
              <p>{{ message2 }}</p>
            </div>
        </b-tab>


        <b-tab title="定制产品" :active="activeTabIndex === 2">
          <div id="page3">
            <p class="p-a">定制产品价格、库存表 单位: 元 (人民币)</p>
            <table>
              <thead>
                <tr>
                  <th style="width: 180px;" scope="col" class="text-center">定制产品</th>
                  <th style="width: 200px;" scope="col" class="text-center">价格: 元(人民币)/台</th>
                  <th style="width: 130px;" scope="col" class="text-center">库存数量</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(val3, index3) in custom" :key="index3">
                  <td class="text-left">{{ val3.prodname }}</td>
                  <td class="text-right">{{ val3.prodprice }}</td>
                  <td class="text-right">
                    <div v-if="val3.quantity !== null">
                      {{ val3.quantity }}
                    </div>
                    <div v-else>
                      无限
                    </div>
                  </td>
                </tr>
              </tbody>
            </table> 
            <div style="margin-top: 10px;margin-left: 0;align-items: center;">
               <span style="width: 600px;">说明: 每次只能购买1台某种定制产品。如果您有其它定制需求(例如: ERP，OA或其它管理信息系统)请单独</span>
            </div>
            <div style="margin-top: 2px;margin-left: 0;align-items: center;">
               <span style="width: 600px;">与我们联系，我们可以为您定制部署或开发。</span>
            </div>
        
            <div style="margin-top: 10px;margin-left: 0;align-items: center;">
              <span style="margin-right: 5px;">请选择定制产品:</span>
              <select id="custom_select" v-model="custom_selected" @change="setCustomPrice()" >
                <template v-for="item in custom">
                  <option v-if="item.quantity != 0" :value="item.prodid + '|' + item.prodprice">{{ item.prodname  }}</option>
                </template>
              </select>

              <span style="margin-left: 30px; margin-right: 10px">请输入IP地址:</span>
              <input id="ip_input" style="width: 120px;" type="text" v-model="customip" placeholder="10.157.1.31"/>
            </div>
          
            <div v-if="ipstr" style="margin-top: 10px;margin-left: 0;align-items: center;">
               <span style="width: 600px; font-weight: bold;">注意:&nbsp;&nbsp; 请输入一个有效的IP地址&nbsp;{{ ipstr }}. </span>
            </div>

            <div v-if="ipstr" style="margin-top: 2px;margin-left: 0;align-items: center;">
               <span style="width: 600px; font-weight: bold;">系统通过DHCP自动分配的IP地址最后一栏的范围是100-249,&nbsp;&nbsp;您手工分配的IP地址最后一栏应该避开这段</span>
            </div>

            <div v-if="ipstr" style="margin-top: 2px;margin-left: 0;align-items: center;">
               <span style="width: 600px; font-weight: bold;">地址.&nbsp;&nbsp;除非您手工调整了系统DHCP自动分配的IP地址范围</span>
            </div>

            <div v-if="ipstr" style="margin-top: 2px;margin-left: 0;align-items: center;">
               <span style="width: 600px; font-weight: bold;">假如您购买的定制产品要挂载到您已经购买的企业网关1(IP地址:10.157.1.1)下,&nbsp;&nbsp;您购买的定制产品IP地址</span>
            </div>

            <div v-if="ipstr" style="margin-top: 2px;margin-left: 0;align-items: center;">
               <span style="width: 600px; font-weight: bold;">可以输入:&nbsp;&nbsp;10.157.1.43&nbsp;&nbsp;(43在2-254范围内,&nbsp;&nbsp;并且避开了100-249)</span>
            </div>

            <div v-if="ipstr" style="margin-top: 2px;margin-left: 0;align-items: center;">
               <span style="width: 600px; font-weight: bold;">假如您购买的定制产品要挂载到您已经购买的企业网关2(IP地址:10.157.2.1)下,&nbsp;&nbsp;您购买的定制产品IP地址</span>
            </div>

            <div v-if="ipstr" style="margin-top: 2px;margin-left: 0;align-items: center;">
               <span style="width: 600px; font-weight: bold;">可以输入:&nbsp;&nbsp;10.157.2.251&nbsp;&nbsp;(251在2-254范围内,&nbsp;&nbsp;并且避开了100-249)</span>
            </div>

            <div style="margin-top: 160px; width: 600px; align-items: center;">
              <span style="margin-right: 5px;">您需要付款:</span>
              <span style="color:#003D79;font-weight:bold;">{{ custom_price }}</span>
              <span style="margin-left: 5px;">元(人民币)</span>
            </div>
        
            <div class="payinfo" style="margin-top: 10px;">
              <span style="height:50px;line-height:50px;">支付方式:</span>
              <div class="waiwei">
                <img
                  src="../assets/media/alipay.png"
                  style="width: 32px;height 32px;margin-left: 5px;float: left;"
                >
                <span style="cursor:default;float:right;margin-left:5px;">支付宝</span>
              </div>
              <button  @click="alipay('page3' + '|' + custom_selected.split('|')[0] + 'custom')">立即支付</button>
            </div>
        
            <div v-if="message3" class="message">
              <p>{{ message3 }}</p>
            </div>
        </b-tab>

      </b-tabs>
    </b-card>
  </div>






</template>

<script>
export default {
    name: 'Shop',
    data() {
        return {
            activeTabIndex: 0, // 初始激活的tab索引
            stat: 0,   // 一个客户是否已经激活公司
            exp: 0, // license 过期日期, epoch值
            amount: '', // 一个客户所有网关客户端的数量
            gwamount: '', // 一个客户已经激活的企业网关的数量
            maxgw: '', // 一个客户能拥有的最大的企业网关数
            gw: null,
            mgw: 1,
            mterm: 1,
            gwDefined: false, // 是否已经定义了默认购买企业网关的数量
            mgwDefined: false,
            mtermDefined: false,
            lowgw: null,
            lowmgw: null,
            lowmterm: null,
            midgw: null, // 中端企业网关数量
            midmgw: null,
            midmterm: null,
            highgw: null, // 高端企业网关数量
            highmgw: null,
            highmterm: null,
            lowgw_max: null, // 低端企业网关最大值
            lowmgw_max: null,
            lowmterm_max: null,
            midgw_max: null,
            midmgw_max: null,
            midmterm_max: null,
            highgw_max: null,
            highmgw_max: null,
            highmterm_max: null,
            product: [],
            product_price: '',
            plan: [], // 流量套餐
            plan_selected: '',
            plan_price: '',
            custom: [],
            custom_selected: '',
            customip: '',
            custom_price: '',
            message1: '',
            message2: '',
            message3: '',
            ipstr: ''
        };
    },
    methods: {
        handleTabChange(newTabIndex) {
            this.activeTabIndex = newTabIndex; // 更新当前激活的tab索引
        },

        alipay(arg1) {
            let page = arg1.split('|')[0]; // arg1的数值类似 page1|1gw_2mgw_3mterm 或 page2|24
            var category;
            var price;
            var duration = '0'; // 流量套餐时长, 用天数表示
            var ip = '1.2.3.4';
            var exp = 0; // 只有当status = 2 时, exp才有值. 当status == 1 或 status == 3时, exp是0

            if (page == 'page1') {
                if ((this.lowgw + this.midgw + this.highgw) == 0 &&
                    (this.lowmgw + this.midmgw + this.highmgw) == 0 &&
                    (this.lowmterm + this.midmterm + this.highmterm) == 0) {
                    this.message1 = '用户至少购买1台企业网关, 移动网关或者移动终端.';
                    return;
                }

                if (this.stat == 1) {
                    if ((this.lowgw + this.midgw + this.highgw) == 0) {
                        this.message1 = '用户首次至少购买1台企业网关, 并且至少购买1台移动网关或者1台移动终端; 或者同时购买两台以上的企业网关.';
                        return;
                    } else if ((this.lowgw + this.midgw + this.highgw) == 1 &&
                        (this.lowmgw + this.midmgw + this.highmgw) == 0 &&
                        (this.lowmterm + this.midmterm + this.highmterm) ==0) {
                        this.message1 = '用户首次至少购买1台企业网关, 并且至少购买1台移动网关或者1台移动终端.';
                        return;
                    }
                } else if ( this.stat == 2 ) {
                    if ((this.lowgw + this.midgw + this.highgw) > (this.maxgw - this.gwamout)) { // 客户购买的企业网关数大于可采购的企业网关数
                        this.message1 = '您可以购买的最大企业网关数为 ' + String(this.maxgw - this.gwamout);
                        return;
                    }
                } else if ( this.stat == 3) {
                    this.message1 = '贵公司的流量套餐已经过期, 请先购买流量套餐后再购买网关设备.';
                    return;
                }

                category = 'product'; // 购买的是产品
                price = this.product_price;
            }

            if (page == 'page2') {
                if (this.stat == 1) {
                    this.message2 = '贵公司还没有购买过网关产品, 目前还不能购买流量产品';
                    return;
                }
                category = 'plan'; // 购买的是流量
                price = this.plan_price;

                duration = arg1.split('|')[2].match(/\d+/g)[1]; // 购买的流量的天数 365, 730 或 1095天
            }

            if (page == 'page3') {
                if (this.stat == 1) {
                    this.message3 = '贵公司还没有购买过网关产品, 目前还不能购买定制产品';
                    return;
                }

                if (this.stat == 3) {
                    this.message3 = '贵公司流量套餐已过期, 请先购买流量套餐再购买定制产品';
                    return;
                }

                if (! this.customip.trim()) {
                    this.message3 = '必须输入定制产品的IP地址';
                    return;
                }
        
                category = 'custom'; // 购买的是定制产品
                price = this.custom_price;

                ip = this.customip;
            }

            if ( this.stat == 2 ) {
                exp = this.exp;
            }

            let subject = arg1.split('|')[1]; // 订单标题/商品标题/交易标题

            var config = {
                method: 'post',
                url: 'alipay',
                data: {
                    username: this.$store.state.username, // 客户端登录的用户名 电子邮箱
                    category: category, // 购买商品的类别
                    subject: subject,
                    price: price,
                    duration: duration, // 购买流量时的流量天数 365, 730 或 1095, 此时该变量是一个字符串
                    customip: ip, // 购买定制产品时的定制IP地址. 购买硬件和流量时该IP地址固定为1.2.3.4, 就是占个位置, 没有意义.
                    status: this.stat,
                    exp: exp
                }
            };
            this.$axios(config)
                .then(response => {
                    if(response.status == 200) {
                        window.location.href = response.data.pay_url;
                    } else {
                        if (page == 'page1') {
                            this.message1 = response.data.message;
                        } else if (page == 'page2') {
                            this.message2 = response.data.message;
                        } else if (page == 'page3') {
                            this.message3 = response.data.message;
                        }
                    }
                })
                .catch(error => {
                    if (error.response) {
                        if (page == 'page1') {
                            this.message1 = '服务器响应错误'; // 服务器响应超时或服务器宕机等原因
                        } else if (page == 'page2'){
                            this.message2 = '服务器响应错误'; // 服务器响应超时或服务器宕机等原因
                        } else if (page == 'page3'){
                            this.message3 = '服务器响应错误'; // 服务器响应超时或服务器宕机等原因
                        }
                    } else if (error.request) {
                        if (page == 'page1') {
                            this.message1 = '请求未发出或未收到服务器响应'; // 例如服务器不允许跨域资源共享(CORS) 
                        } else if (page == 'page2') {
                            this.message2 = '请求未发出或未收到服务器响应'; // 例如服务器不允许跨域资源共享(CORS) 
                        } else if (page == 'page3') {
                            this.message3 = '请求未发出或未收到服务器响应'; // 例如服务器不允许跨域资源共享(CORS) 
                        }
                    } else {
                        if (page == 'page1') {
                            this.message1 = '发生未知错误';
                        } else if (page == 'page2') {
                            this.message2 = '发生未知错误';
                        } else if (page == 'page3') {
                            this.message3 = '发生未知错误';
                        }
                    }
                });
        },

        setProductPrice() {
            if (isNaN(this.lowgw) || this.lowgw === "") {
                this.lowgw = 0;
            }

            if (isNaN(this.midgw) || this.midgw === "") {
                this.midgw = 0;
            }

            if (isNaN(this.highgw) || this.highgw === "") {
                this.highgw = 0;
            }

            if (isNaN(this.lowmgw) || this.lowmgw === "") {
                this.lowmgw = 0;
            }

            if (isNaN(this.midmgw) || this.midmgw === "") {
                this.midmgw = 0;
            }

            if (isNaN(this.highmgw) || this.highmgw === "") {
                this.highmgw = 0;
            }

            if (isNaN(this.lowmterm) || this.lowmterm === "") {
                this.lowmterm = 0;
            }

            if (isNaN(this.midmterm) || this.midmterm === "") {
                this.midmterm = 0;
            }

            if (isNaN(this.highmterm) || this.highmterm === "") {
                this.highmterm = 0;
            }

            this.product_price = this.lowgw * this.product[0].prodprice +
                this.midgw * this.product[1].prodprice +
                this.highgw * this.product[2].prodprice +
                this.lowmgw * this.product[3].prodprice +
                this.midmgw * this.product[4].prodprice +
                this.highmgw * this.product[5].prodprice +
                this.lowmterm * this.product[6].prodprice +
                this.midmterm * this.product[7].prodprice +
                this.highmterm * this.product[8].prodprice;
        },

        setPlanPrice() {
            if (this.stat == 1) {
                this.plan_price = '';
                this.message2 = '贵公司还没有购买过网关产品, 目前还不能购买流量产品';
            } else {
                this.plan_price = this.plan_selected.split('|')[1] * this.amount;
            }
        },

        setCustomPrice() {
            if (this.stat == 1) {
                this.custom_price = '';
                this.message3 = '贵公司还没有购买过网关产品, 目前还不能购买定制产品';
            } else if (this.stat == 2) {
                this.custom_price = this.custom_selected.split('|')[1];
            } else if (this.stat == 3) {
                this.custom_price = '';
                this.message3 = '贵公司流量套餐已过期, 请先购买流量套餐再购买定制产品';
            }
        },

//        validate(event, maxRef, inputRef) {
//            //if (event.target.value < 0) {
//            if (this.$refs.lowmterm_input.value < 0) {
//                inputRef = 0;
//            } else if (this.$refs.lowmterm_input.value > maxRef) {
//                inputRef = maxRef;
//            }
//        },

        validate(event, inputField, maxRef) {
            //if (this.$refs.lowmterm_input.value < 0) {
            if (event.target.value < 0) {
                this[inputField] = 0;
            } else if (event.target.value > maxRef) {
                this[inputField] = maxRef;
            }
        },

        validateGw() {
            if (this.gw < 0) {
                this.gw = 0;
            } 
        },

        validateMgw() {
            if (this.mgw < 0) {
                this.mgw = 0;
            } else if (this.mgw > 2000) {
                this.mgw = 2000;
            }
        },

        validateMterm() {
            if (this.mterm < 0) {
                this.mterm = 0;
            } else if (this.mterm > 2000) {
                this.mterm = 2000;
            }
        }
    },

    beforeCreate() {
        var config = {
            method: 'post',
            url: 'price',
            data: {}
        };
        this.$axios(config)
            .then(response => {
                if(response.status == 200) {
                    this.stat = response.data.stat.status;
                    this.exp = 0;
                    this.maxgw = response.data.stat.maxgw;

                    this.product = response.data.product;
                    this.plan = response.data.plan;
                    this.custom = response.data.custom;

                    if (this.stat == 1) {
                        this.amount = 0; // 客户还没有购买过网关产品, 因此已激活的客户端的数量为0
                        this.gwamount = 0; // 客户激活的企业网关数为0
                        this.plan_price = '';
                        this.message2 = '贵公司还没有购买过网关产品, 目前还不能购买流量产品';
                        this.custom_price = '';
                        this.message3 = '贵公司还没有购买过网关产品, 目前还不能购买定制产品';
                    } else if (this.stat == 2) {
                        this.exp = response.data.stat.exp;
                        this.amount = response.data.stat.amount;
                        this.gwamount = response.data.stat.gwamount;
                        this.ipstr = response.data.stat.ipstr;
                        this.plan_price = this.amount * response.data.plan[0].planprice; // this.plan_price = this.plan_selected.split('|')[1]; // 流量价格需要计算
                        for (let item of this.custom) {
                            if (item.quantity == 0) {
                                continue;
                            } else {
                                this.custom_price = item.prodprice;
                                break;
                            }
                        }
                    } else if (this.stat == 3) {
                        this.amount = response.data.stat.amount;
                        this.gwamount = response.data.stat.gwamount;
                        this.plan_price = this.amount * response.data.plan[0].planprice; // this.plan_price = this.plan_selected.split('|')[1]; // 流量价格需要计算
                        this.custom_price = '';
                        this.message3 = '贵公司流量套餐已过期, 请先购买流量套餐再购买定制产品';
                    }

                    for (let item of this.product) {
                        if (item['prodid'] == 1) { // 企业网关(低端)
                            if (item['quantity'] > 0) { // 企业网关(低端)的库存大于0
                                if ((this.maxgw - this.gwamount) == 0) { // 该企业还可以购买的企业网关数量
                                    this.lowgw = 0;
                                    this.lowgw_max = 0;
                                } else {
                                    if(!this.gwDefined) {
                                        if (item['quantity'] >= (this.maxgw - this.gwamount)) { // 企业网关(低端)库存大于等于该企业还可以购买的企业网关数量
                                            this.lowgw = 1;
                                            this.lowgw_max = this.maxgw - this.gwamount;
                                        } else {
                                            this.lowgw = 1;
                                            this.lowgw_max = item['quantity'];
                                        }

                                        this.gwDefined = true;
                                    }
                                }
                            } else if (item['quantity'] === null) { // 企业网关(低端)的库存不限量
                                if ((this.maxgw - this.gwamount) == 0) { // 该企业还可以购买的企业网关数量
                                    this.lowgw = 0;
                                    this.lowgw_max = 0;
                                } else {
                                    if(!this.gwDefined) {
                                        this.lowgw = 1;
                                        this.lowgw_max = this.maxgw - this.gwamount;

                                        this.gwDefined = true;
                                    }
                                }
                            } else if (item['quantity'] <= 0) { // 企业网关(低端)的库存为0
                                this.lowgw = 0;
                                this.lowgw_max = 0;
                            }
                        }

                        if (item['prodid'] == 2) { // 企业网关(中端)
                            if (item['quantity'] > 0) { // 企业网关(中端)的库存大于0
                                if ((this.maxgw - this.gwamount) == 0) { // 该企业还可以购买的企业网关数量
                                    this.midgw = 0;
                                    this.midgw_max = 0;
                                } else {
                                    if (item['quantity'] >= (this.maxgw - this.gwamount)) { // 企业网关(中端)库存大于等于该企业还可以购买的企业网关数量
                                        if (!this.gwDefined) {
                                            this.midgw = 1;
                                            this.gwDefined = true;
                                        } else {
                                            this.midgw = 0;
                                        }

                                        this.midgw_max = this.maxgw - this.gwamount;
                                    } else {
                                        if (!this.gwDefined) {
                                            this.midgw = 1;
                                            this.gwDefined = true;
                                        } else {
                                            this.midgw = 0;
                                        }

                                        this.midgw_max = item['quantity'];
                                    }
                                }
                            } else if (item['quantity'] === null) { // 企业网关(中端)的库存不限量
                                if ((this.maxgw - this.gwamount) == 0) { // 该企业还可以购买的企业网关数量
                                    this.midgw = 0;
                                    this.midgw_max = 0;
                                } else {
                                    if (!this.gwDefined) {
                                        this.midgw = 1;
                                        this.gwDefined = true;
                                    } else {
                                        this.midgw = 0;
                                    }

                                    this.midgw_max = this.maxgw - this.gwamount;
                                }
                            } else if (item['quantity'] <= 0) { // 企业网关(中端)的库存为0
                                this.midgw = 0;
                                this.midgw_max = 0;
                            }
                        }

                        if (item['prodid'] == 3) { // 企业网关(高端)
                            if (item['quantity'] > 0) { // 企业网关(高端)的库存大于0
                                if ((this.maxgw - this.gwamount) == 0) { // 该企业还可以购买的企业网关数量
                                    this.higgw = 0;
                                    this.highgw_max = 0;
                                } else {
                                    if (item['quantity'] >= (this.maxgw - this.gwamount)) { // 企业网关(高端)库存大于等于该企业还可以购买的企业网关数量
                                        if (!this.gwDefined) {
                                            this.highgw = 1;
                                            this.gwDefined = true;
                                        } else {
                                            this.highgw = 0;
                                        }

                                        this.highgw_max = this.maxgw - this.gwamount;
                                    } else {
                                        if (!this.gwDefined) {
                                            this.highgw = 1;
                                            this.gwDefined = true;
                                        } else {
                                            this.highgw = 0;
                                        }

                                        this.highgw_max = item['quantity'];
                                    }
                                }
                            } else if (item['quantity'] === null) { // 企业网关(高端)的库存不限量
                                if ((this.maxgw - this.gwamount) == 0) { // 该企业还可以购买的企业网关数量
                                    this.highgw = 0;
                                    this.highgw_max = 0;
                                } else {
                                    if (!this.gwDefined) {
                                        this.highgw = 1;
                                        this.gwDefined = true;
                                    } else {
                                        this.highgw = 0;
                                    }

                                    this.highgw_max = this.maxgw - this.gwamount;
                                }
                            } else if (item['quantity'] <= 0) { // 企业网关(高端)的库存为0
                                this.highgw = 0;
                                this.highgw_max = 0;
                            }
                        }

                        if (item['prodid'] == 4) { // 移动网关(低端)
                            if (item['quantity'] > 0) { // 移动网关(低端)的库存大于0
                                if (!this.mgwDefined) {
                                    this.lowmgw = 1; // 移动网关(低端)默认购买数量
                                    this.mgwDefined = true;
                                } else {
                                    this.lowmgw = 0;
                                }

                                this.lowmgw_max = item['quantity'];
                            } else if (item['quantity'] === null) { // 移动网关(低端)的库存不限量
                                if (!this.mgwDefined) {
                                    this.lowmgw = 1;
                                    this.mgwDefined = true;
                                } else {
                                    this.lowmgw = 0;
                                }

                                this.lowmgw_max = 1000; // 最大可购买数量
                            } else if (item['quantity'] <= 0) { // 移动网关(低端)的库存为0
                                this.lowmgw = 0;
                                this.lowmgw_max = 0;
                            }
                        }

                        if (item['prodid'] == 5) { // 移动网关(中端)
                            if (item['quantity'] > 0) { // 移动网关(中端)的库存大于0
                                if (!this.mgwDefined) {
                                    this.midmgw = 1; // 移动网关(中端)默认购买数量
                                    this.mgwDefined = true;
                                } else {
                                    this.midmgw = 0;
                                }

                                this.midmgw_max = item['quantity'];
                            } else if (item['quantity'] === null) { // 移动网关(中端)的库存不限量
                                if (!this.mgwDefined) {
                                    this.midmgw = 1;
                                    this.mgwDefined = true;
                                } else {
                                    this.midmgw = 0;
                                }

                                this.midmgw_max = 1000; // 最大可购买数量
                            } else if (item['quantity'] <= 0) { // 移动网关(中端)的库存为0
                                this.midmgw = 0;
                                this.midmgw_max = 0;
                            }
                        }

                        if (item['prodid'] == 6) { // 移动网关(高端)
                            if (item['quantity'] > 0) { // 移动网关(高端)的库存大于0
                                if (!this.mgwDefined) {
                                    this.highmgw = 1; // 移动网关(高端)默认购买数量
                                    this.mgwDefined = true;
                                } else {
                                    this.highmgw = 0;
                                }

                                this.highmgw_max = item['quantity'];
                            } else if (item['quantity'] === null) { // 移动网关(高端)的库存不限量
                                if (!this.mgwDefined) {
                                    this.highmgw = 1;
                                    this.mgwDefined = true;
                                } else {
                                    this.highmgw = 0;
                                }

                                this.highmgw_max = 1000; // 最大可购买数量
                            } else if (item['quantity'] <= 0) { // 移动网关(高端)的库存为0
                                this.highmgw = 0;
                                this.highmgw_max = 0;
                            }
                        }

                        if (item['prodid'] == 7) { // 移动终端(低端)
                            if (item['quantity'] > 0) { // 移动终端(低端)的库存大于0
                                if (!this.mtermDefined) {
                                    this.lowmterm = 1; // 移动终端(低端)默认购买数量
                                    this.mtermDefined = true;
                                } else {
                                    this.lowmterm = 0;
                                }

                                this.lowmterm_max = item['quantity'];
                            } else if (item['quantity'] === null) { // 移动终端(低端)的库存不限量
                                if (!this.mtermDefined) {
                                    this.lowmterm = 1;
                                    this.mtermDefined = true;
                                } else {
                                    this.lowmterm = 0;
                                }

                                this.lowmterm_max = 1000; // 最大可购买数量
                            } else if (item['quantity'] <= 0) { // 移动终端(低端)的库存为0
                                this.lowmterm = 0;
                                this.lowmterm_max = 0;
                            }
                        }

                        if (item['prodid'] == 8) { // 移动终端(中端)
                            if (item['quantity'] > 0) { // 移动终端(中端)的库存大于0
                                if (!this.mtermDefined) {
                                    this.midmterm = 1; // 移动终端(中端)默认购买数量
                                    this.mtermDefined = true;
                                } else {
                                    this.midmterm = 0;
                                }

                                this.midmterm_max = item['quantity'];
                            } else if (item['quantity'] === null) { // 移动终端(中端)的库存不限量
                                if (!this.mtermDefined) {
                                    this.midmterm = 1;
                                    this.mtermDefined = true;
                                } else {
                                    this.midmterm = 0;
                                }

                                this.midmterm_max = 1000; // 最大可购买数量
                            } else if (item['quantity'] <= 0) { // 移动终端(中端)的库存为0
                                this.midmterm = 0;
                                this.midmterm_max = 0;
                            }
                        }

                        if (item['prodid'] == 9) { // 移动终端(高端)
                            if (item['quantity'] > 0) { // 移动终端(高端)的库存大于0
                                if (!this.mtermDefined) {
                                    this.highmterm = 1; // 移动终端(高端)默认购买数量
                                    this.mtermDefined = true;
                                } else {
                                    this.highmterm = 0;
                                }

                                this.highmterm_max = item['quantity'];
                            } else if (item['quantity'] === null) { // 移动终端(高端)的库存不限量
                                if (!this.mtermDefined) {
                                    this.highmterm = 1;
                                    this.mtermDefined = true;
                                } else {
                                    this.highmterm = 0;
                                }

                                this.highmterm_max = 1000; // 最大可购买数量
                            } else if (item['quantity'] <= 0) { // 移动终端(高端)的库存为0
                                this.highmterm = 0;
                                this.highmterm_max = 0;
                            }
                        }
                    } // 至此网关类产品的数量初始化工作完成

                    this.product_price = this.lowgw * this.product[0].prodprice +
                        this.midgw * this.product[1].prodprice +
                        this.highgw * this.product[2].prodprice +
                        this.lowmgw * this.product[3].prodprice +
                        this.midmgw * this.product[4].prodprice +
                        this.highmgw * this.product[5].prodprice +
                        this.lowmterm * this.product[6].prodprice +
                        this.midmterm * this.product[7].prodprice +
                        this.highmterm * this.product[8].prodprice;
                    this.plan_selected = this.plan[0].planid + '|' + this.plan[0].planprice + '|' + this.plan[0].planname;
                    for (let item of this.custom) {
                        if (item.quantity == 0) {
                            continue;
                        } else {
                            this.custom_selected = item.prodid + '|'  + item.prodprice;
                            break;
                        }
                    }
                }
            })
            .catch(error => {
                if (error.response) {
                    this.message1 = '服务器响应错误'; // 服务器响应超时或服务器宕机等原因
                } else if (error.request) {
                    this.message1 = '请求未发出或未收到服务器响应'; // 例如服务器不允许跨域资源共享(CORS) 
                } else {
                    this.message1 = '发生未知错误';
                }
            });

    }

};
</script>

<style scoped>
.tabpage {
  margin-left: 110px;
  padding: 0;
  height: 600px;
  width: 90%;
}

.p-a {
  margin-top: 25px;
  margin-bottom: 10px;
  color: #2185d0!important;
  font-weight: bold;
  font-size: 24px;
}

.p-b {
  margin-top: 10px;
  margin-bottom: 10px;
}

table {
  border-collapse: collapse;
}

th,td {
  border: 1px solid #666;
  padding: 5px;
}

.slash-wrap {
  position: relative;
  box-sizing: border-box;
  width: 150px;
  height: 80px;
 }

.t-body {
  width: 250px;
}

.slash {
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  width: 170px;
  height: 1px;
  background-color:#000;
  transform: rotate(28.072486935852954deg); 
  transform-origin: top left;
}

.left {
  position: absolute;
  left: 15px;
  bottom: 15px;
}

.right {
  position: absolute;
  right: 15px;
  top: 15px;
} 

.payinfo {
  display: flex;
  margin: 0;
  padding: 0;
  width: 600px;
  height: 40px;
  align-items: center;
}

.waiwei {
  border: 1px solid #3a8ee6;
  margin-left: 10px;
  width: 150px;
  height: 40px;
  display: flex;
  align-items: center;
  border-radius: 5px;
}

button{
  margin-left: 100px;
  width:100px;
  height:40px;
  border-radius:3px;
  border:none;
  background-color:#1A8CDB;
  color:#fff;
  font-size:16px;
}

.message{
  margin-top: 10px;
  width:600px;
}

</style>
